import { render, staticRenderFns } from "./newgiveMedici.vue?vue&type=template&id=6366aa2c&scoped=true"
import script from "./newgiveMedici.vue?vue&type=script&lang=js"
export * from "./newgiveMedici.vue?vue&type=script&lang=js"
import style0 from "./newgiveMedici.vue?vue&type=style&index=0&id=6366aa2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366aa2c",
  null
  
)

export default component.exports